var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { DropdownItem } from '../../../../../shared/dropdown-item';
import { ArrowStyleType } from '../../../../view-data/shared/line/general/arrow-style-type';
var ArrowStyleTypeService = /** @class */ (function () {
    function ArrowStyleTypeService(svgService) {
        this.svgService = svgService;
        this.arrowStyleTypes = [];
    }
    ArrowStyleTypeService.prototype.getAll = function () {
        if (!this.arrowStyleTypes.length) {
            this.arrowStyleTypes.push(new DropdownItem(ArrowStyleType.CommonLeft, this.getSingleArrowSVG(ArrowStyleType.CommonLeft)));
            this.arrowStyleTypes.push(new DropdownItem(ArrowStyleType.CommonRight, this.getSingleArrowSVG(ArrowStyleType.CommonRight)));
            this.arrowStyleTypes.push(new DropdownItem(ArrowStyleType.CommonBoth, this.getBothArrowSVG(ArrowStyleType.CommonBoth)));
            this.arrowStyleTypes.push(new DropdownItem(ArrowStyleType.SolidLeft, this.getSingleArrowSVG(ArrowStyleType.SolidLeft)));
            this.arrowStyleTypes.push(new DropdownItem(ArrowStyleType.SolidRight, this.getSingleArrowSVG(ArrowStyleType.SolidRight)));
            this.arrowStyleTypes.push(new DropdownItem(ArrowStyleType.SolidBoth, this.getBothArrowSVG(ArrowStyleType.SolidBoth)));
        }
        return this.arrowStyleTypes;
    };
    ArrowStyleTypeService.prototype.getSingleArrowSVG = function (type) {
        var svg = this.svgService.getSVGSVGElement('100%', '18');
        var refX = this.isSolid(type) ? '6' : '9';
        var marker = this.getMarker(refX, "arrow" + type);
        var dParm = 'M2,2 L10,6 L2,10';
        if (type === ArrowStyleType.SolidLeft || type === ArrowStyleType.SolidRight) {
            dParm = 'M2,2 L10,6 L2,10 z';
        }
        var path = this.getPath(dParm, this.isSolid(type));
        marker.appendChild(path);
        svg.appendChild(marker);
        var line = this.getLine('210', '11', '5', '11', "url(#arrow" + type + ")");
        if (type === ArrowStyleType.CommonRight || type === ArrowStyleType.SolidRight) {
            line = this.getLine('5', '11', '210', '11', "url(#arrow" + type + ")");
        }
        svg.appendChild(line);
        return svg.outerHTML;
    };
    ArrowStyleTypeService.prototype.getBothArrowSVG = function (type) {
        var svg = this.svgService.getSVGSVGElement('100%', '18');
        var refX = this.isSolid(type) ? '6' : '4';
        var leftMarker = this.getMarker(refX, "leftArrow" + type);
        var leftD = type === ArrowStyleType.SolidBoth ? 'M2,6 L10,2 L10,10 z' : 'M10,2 L2,6 L10,10';
        var leftPath = this.getPath(leftD, this.isSolid(type));
        leftMarker.appendChild(leftPath);
        svg.appendChild(leftMarker);
        var rightRefX = this.isSolid(type) ? '6' : '9';
        var rightMarker = this.getMarker(rightRefX, "rightArrow" + type);
        var rightD = type === ArrowStyleType.SolidBoth ? 'M2,2 L10,6 L2,10 z' : 'M2,2 L10,6 L2,10';
        var rightPath = this.getPath(rightD, this.isSolid(type));
        rightMarker.appendChild(rightPath);
        svg.appendChild(rightMarker);
        var line = this.getLine('5', '11', '210', '11', "url(#rightArrow" + type + ")", "url(#leftArrow" + type + ")");
        svg.appendChild(line);
        return svg.outerHTML;
    };
    ArrowStyleTypeService.prototype.getMarker = function (refX, id) {
        var marker = this.svgService.getSVGMarkerElement(id, '12', '12', refX, '6');
        marker.setAttributeNS(null, 'viewBox', '0 0 12 12');
        marker.setAttributeNS(null, 'orient', 'auto');
        return marker;
    };
    ArrowStyleTypeService.prototype.getPath = function (d, isSolid) {
        var path = this.svgService.getSVGPathElement(d);
        if (isSolid) {
            path.setAttributeNS(null, 'fill', '#333333');
        }
        else {
            path.setAttributeNS(null, 'stroke', '#333333');
            path.setAttributeNS(null, 'stroke-width', '1');
            path.setAttributeNS(null, 'fill', 'none');
        }
        return path;
    };
    ArrowStyleTypeService.prototype.getLine = function (x1, y1, x2, y2, arrow, arrow2) {
        var line = this.svgService.getSVGLineElement(x1, y1, x2, y2, '#333333', '1');
        if (arrow2) {
            line.setAttributeNS(null, 'marker-start', arrow2);
        }
        line.setAttributeNS(null, 'marker-end', arrow);
        return line;
    };
    ArrowStyleTypeService.prototype.isSolid = function (type) {
        return type === ArrowStyleType.SolidLeft || type === ArrowStyleType.SolidRight || type === ArrowStyleType.SolidBoth;
    };
    ArrowStyleTypeService = __decorate([
        Injectable()
    ], ArrowStyleTypeService);
    return ArrowStyleTypeService;
}());
export { ArrowStyleTypeService };
